import { call, put, takeEvery } from 'redux-saga/effects';

import { getVisualStyleFacetValues } from 'js/shared/providers/ImageLibrary';
import {
  LOAD_VISUAL_STYLES,
  VisualStyleItem,
  loadVisualStylesSuccess,
  loadVisualStylesFailure
} from 'js/actionCreators/imageSearchActions';

const STREAMLINE_STYLE: VisualStyleItem = {
  facetId: 'streamline',
  facetValue: 'streamline',
  iconKey: 'streamline',
  label: 'Modern',
  description: 'Images from Streamline'
};

const STYLE_DESCRIPTIONS: Record<string, string> = {
  cartoon: 'Bold, colorful, filled',
  minimal: 'Simple, clean, uncluttered',
  simple: 'Clean, minimal, flat',
  scribble: 'Clean, minimal, flat',
  conceptual: 'Abstract, symbolic, metaphorical',
  abstract: 'Abstract, symbolic, metaphorical',
  realistic: 'Detailed, realistic, photo-like',
  stylized: 'Artistic, exaggerated, unique'
};

function* handleLoadVisualStyles() {
  try {
    const response: { facetId: string; values: Array<{ value: string; count: number }> } =
      yield call(getVisualStyleFacetValues);
    const incomingStyles: VisualStyleItem[] = response.values.map(({ value }) => ({
      facetId: response.facetId,
      facetValue: value,
      iconKey: value.replace(/\s/g, '').toLowerCase(),
      label: value.charAt(0).toUpperCase() + value.slice(1),
      description: STYLE_DESCRIPTIONS[value.toLowerCase()] ?? ''
    }));

    // Put streamline into the 3rd position in the list
    const styles = incomingStyles.toSpliced(2, 0, STREAMLINE_STYLE);
    yield put(loadVisualStylesSuccess(styles));
  } catch {
    yield put(loadVisualStylesFailure());
  }
}

export default function* visualStylesSaga() {
  yield takeEvery(LOAD_VISUAL_STYLES, handleLoadVisualStyles);
}
